export const MUSIC_RIBBON_TYPE = 'genericClaroMusicaRibbon';
export const RECORDINGS_VIEWED = 'Compradas--Rentadas_carrouselder';
export const NODESEARCH = '/talent';



// WEBPACK FOOTER //
// ./src/components/RibbonGrid/constants.js